import { render, staticRenderFns } from "./ConstructMovingPopup.vue?vue&type=template&id=532d5622"
import script from "./ConstructMovingPopup.vue?vue&type=script&lang=ts"
export * from "./ConstructMovingPopup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports